/**
 * Main-thread cache for the `x-team-id` header value — the deployment's one
 * hidden workspace (ADR-023), which `rpcProtectedActiveTeamProcedure` requires.
 *
 * - `setActiveTeamIdForRequests(id)` — seeded by `authLoader` from
 *   `user.activeTeamAppId` (or `teams.getDefaultTeam`) before any page mounts,
 *   re-seeded by `WorkspaceProvider`, cleared on sign-out.
 * - `getActiveTeamIdReady()` — awaited by the RPC link's `headers()`. Pends
 *   until the cache has been set at least once (even to `null`), so no request
 *   leaves with an *unset* cache; afterwards it resolves immediately.
 *
 * "Unset" and `null` differ: unset → wait for the seed; `null` → send without
 * `x-team-id` (signed out / session-only endpoints).
 */

let seeded = false;
let resolveFirstSeed: (teamId: string | null) => void = () => {};
let ready: Promise<string | null> = new Promise((resolve) => {
	resolveFirstSeed = resolve;
});

export const setActiveTeamIdForRequests = (teamId: string | null): void => {
	if (!seeded) {
		seeded = true;
		resolveFirstSeed(teamId);
	}
	// Later awaiters get the latest value right away.
	ready = Promise.resolve(teamId);
};

export const getActiveTeamIdReady = (): Promise<string | null> => ready;
